/**
 * After mutating project-linked locations (create / edit / delete), call
 * {@link notifyProjectLocationsChanged} so other tabs of the same browser
 * refetch immediately. Other users/machines rely on polling and visibility
 * refetch in `ProjectLocationsProvider`.
 */
export const PROJECT_LOCATIONS_BROADCAST_CHANNEL = "waas:project-locations:v1";

export type ProjectLocationsBroadcastMessage = {
  type: "project-locations-changed";
  /** If omitted or empty, every listener with an active project refetches. */
  projectIds?: string[] | null;
};

export function notifyProjectLocationsChanged(affectedProjectIds?: string[] | null): void {
  if (typeof window === "undefined" || typeof BroadcastChannel === "undefined") {
    return;
  }
  try {
    const bc = new BroadcastChannel(PROJECT_LOCATIONS_BROADCAST_CHANNEL);
    bc.postMessage({
      type: "project-locations-changed",
      projectIds: affectedProjectIds ?? null,
    } satisfies ProjectLocationsBroadcastMessage);
    bc.close();
  } catch {
    /* ignore */
  }
}
